import { useSearchParams } from 'react-router-dom';
import { ISearchParams } from 'types/searchParams';

const useCustomSearchParams = (): [typeof searchAsObject[], typeof setSearch] => {
  const [search, setSearch] = useSearchParams();
  const searchAsObject = Object.fromEntries(
    new URLSearchParams(search),
  ) as never as ISearchParams;

  const isEmpty = Object.keys(searchAsObject).length === 0;
  const preparedSearchParams = isEmpty ? [] : [searchAsObject];

  return [preparedSearchParams, setSearch];
};

export default useCustomSearchParams;
